/* PT · Design overview: each panel fades up 12px the first time it scrolls into view (300ms,
   once). Minimal by design — the page is a document. Reduced motion = fade only (CSS). */
(function () {
  "use strict";
  if (window.__ptRd) return;
  window.__ptRd = true;
  function reveal(root) {
    var els = [].slice.call((root || document).querySelectorAll(".rd-rv:not(.rd-in)"));
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("rd-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add("rd-in");
        io.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.04 });
    els.forEach(function (e) { io.observe(e); });
  }
  /* .rd-grow (02 background: the B&W photos, then the graph): each starts once a third of it is
     on screen, so the graph draws while it is being looked at rather than as the panel edge appears.
     Nothing animates before its image has arrived: the images are fetched a screen ahead (Safari's
     own lazy loading starts very late) and each step waits for them, capped so a slow connection
     never holds the section back for long. */
  function ready(imgs, cap) {
    return new Promise(function (done) {
      var left = imgs.length, t = setTimeout(done, cap);
      if (!left) { clearTimeout(t); done(); return; }
      imgs.forEach(function (img) {
        function one() { if (--left === 0) { clearTimeout(t); done(); } }
        if (img.complete && img.naturalWidth) one();
        else { img.addEventListener("load", one, { once: true }); img.addEventListener("error", one, { once: true }); }
      });
    });
  }
  function fetchNow(box) {
    [].forEach.call(box.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = "eager"; });
  }
  function grow(root) {
    var els = [].slice.call((root || document).querySelectorAll(".rd-grow:not(.rd-in)"));
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("rd-in"); }); return; }
    /* photos: wait for their images, then settle in; remembers when they started */
    function startPhotos(grid) {
      if (!grid.__rdP) {
        fetchNow(grid);
        grid.__rdP = ready([].slice.call(grid.querySelectorAll(".rd-g2-pair img, .rd-g2-drawer img")), 6000).then(function () {
          grid.classList.add("rd-in");
          grid.__rdT = Date.now();
        });
      }
      return grid.__rdP;
    }
    var pre = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { fetchNow(en.target); pre.unobserve(en.target); } });
    }, { rootMargin: "0px 0px 100% 0px" });
    /* the graph: starts with the photos (no waiting for it to scroll into view on its own), then
       draws once its image has loaded and the photos are nearly done (--rd-pdone in pt-rd.css) */
    function startGraph(grid) {
      [].forEach.call(grid.querySelectorAll(".rd-g2-chart.rd-grow:not(.rd-in)"), function (el) {
        if (el.__rdG) return;
        el.__rdG = true;
        io.unobserve(el);
        var img = el.querySelector("img");
        startPhotos(grid).then(function () {
          return ready(img ? [img] : [], 15000);
        }).then(function () {
          var pdone = parseFloat(getComputedStyle(grid).getPropertyValue("--rd-pdone")) * 1000 || 0;
          setTimeout(function () { el.classList.add("rd-in"); }, Math.max(0, grid.__rdT + pdone - Date.now()));
        });
      });
    }
    /* starts as soon as the section's top edge is a little way into the screen */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var grid = el.closest(".rd-grow.rd-g2");
        if (!grid) { el.classList.add("rd-in"); return; }
        io.unobserve(grid);
        startPhotos(grid);
        startGraph(grid);
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0 });
    els.forEach(function (e) { io.observe(e); if (e.classList.contains("rd-g2")) pre.observe(e); });
  }
  /* slide indicator under each phone swipe row: one dot per slide, the current one a short bar;
     tapping a dot glides to that slide. Hidden whenever the row doesn't scroll (desktop grids). */
  function dots(root) {
    [].forEach.call((root || document).querySelectorAll(".rd-swipe"), function (row) {
      if (row.__rdDots) return;
      /* slides = the row's children, or explicit stops (the prototype strip: one image, five stops) */
      var slides = [].slice.call(row.querySelectorAll("[data-rd-slide]"));
      if (!slides.length) slides = [].slice.call(row.children);
      if (slides.length < 2) return;
      var bar = document.createElement("div");
      bar.className = "rd-dots";
      bar.setAttribute("role", "group");
      bar.setAttribute("aria-label", "Slides");
      var btns = slides.map(function (sl, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "rd-dot";
        b.setAttribute("aria-label", "Show slide " + (i + 1) + " of " + slides.length);
        b.addEventListener("click", function () {
          var r = row.getBoundingClientRect(), s = sl.getBoundingClientRect();
          row.scrollTo({ left: row.scrollLeft + (s.left - r.left) - (r.width - s.width) / 2, behavior: "smooth" });
        });
        bar.appendChild(b);
        return b;
      });
      row.insertAdjacentElement("afterend", bar);
      row.classList.add("rd-has-dots");
      row.__rdDots = bar;
      var cur = -1, raf = 0;
      function update() {
        raf = 0;
        var r = row.getBoundingClientRect(), mid = r.left + r.width / 2, best = 0, bestD = Infinity;
        if (row.scrollLeft <= 2) best = 0;
        else if (row.scrollLeft >= row.scrollWidth - row.clientWidth - 2) best = slides.length - 1;
        else slides.forEach(function (sl, i) {
          var s = sl.getBoundingClientRect(), d = Math.abs(s.left + s.width / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        if (best === cur) return;
        if (cur > -1) btns[cur].removeAttribute("aria-current");
        btns[best].setAttribute("aria-current", "true");
        cur = best;
      }
      function fit() { bar.hidden = row.scrollWidth <= row.clientWidth + 2; update(); }
      row.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      if ("ResizeObserver" in window) new ResizeObserver(fit).observe(row); else window.addEventListener("resize", fit);
      /* the row only starts to scroll once its images have their width */
      [].forEach.call(row.querySelectorAll("img"), function (im) { if (!im.complete) im.addEventListener("load", fit, { once: true }); });
      fit();
    });
  }
  /* swipe rows: the slides parked off to the side are fetched as soon as the slides on screen have
     loaded (not before), so swiping never waits on a download; Safari otherwise only requests them
     as they slide into view */
  function preloadSlides(root) {
    [].forEach.call((root || document).querySelectorAll(".rd-swipe"), function (row) {
      if (row.__rdPre) return;
      row.__rdPre = true;
      var r = row.getBoundingClientRect(), shown = [], parked = 0;
      [].forEach.call(row.children, function (sl) {
        var s = sl.getBoundingClientRect(), img = sl.querySelector("img");
        if (!img) return;
        if (s.left < r.right && s.right > r.left) shown.push(img); else parked++;
      });
      if (!parked) return;
      ready(shown, 20000).then(function () { fetchNow(row); });
    });
  }
  /* 04 dial: once the tile is on screen and both images have loaded, the tripod + phones and the dial
     fade in together, and the white shimmer starts breathing along the ticks shortly after */
  function dial(root) {
    var els = [].slice.call((root || document).querySelectorAll(".rd-dial--anim:not(.rd-in)"));
    if (!els.length) return;
    var still = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (still || !("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("rd-in", "rd-dial-done"); }); return; }
    /* the hinge in px of the image box, allowing for object-fit (contain or cover) and the sliders;
       from/span = the arc the ticks occupy (degrees clockwise from straight up), with a little margin */
    function hinge(el, img) {
      var w = img.clientWidth, h = img.clientHeight, r = img.naturalWidth / img.naturalHeight;
      var wide = w / h > r, cover = getComputedStyle(img).objectFit === "cover";
      var dw = wide === cover ? w : h * r, dh = wide === cover ? w / r : h;
      var pos = getComputedStyle(img).objectPosition.split(" ").map(function (v) { return parseFloat(v) / 100; });
      var from = parseFloat(el.dataset.a0) - 8;
      return {
        x: (w - dw) * (isNaN(pos[0]) ? .5 : pos[0]) + dw * parseFloat(el.dataset.cx) / 100,
        y: (h - dh) * (isNaN(pos[1]) ? .5 : pos[1]) + dh * parseFloat(el.dataset.cy) / 100,
        from: from, span: parseFloat(el.dataset.a1) - from + 8
      };
    }
    /* after the reveal: a soft band of light breathes up and down the ticks. A wrapper square centred
       on the hinge carries a fixed conic band as its mask and swings around the hinge; the white ticks
       layer inside counter-rotates so the ticks stay put and only the light moves (compositor-only) */
    function breathe(el, img) {
      if (!el.classList.contains("rd-dial--breathe") || !el.dataset.ticks || !el.animate) return;
      var wrap = document.createElement("div"), t = new Image(), g;
      wrap.className = "rd-glint";
      wrap.setAttribute("aria-hidden", "true");
      t.className = "rd-glint-img";
      t.alt = "";
      t.decoding = "async";
      wrap.appendChild(t);
      function place() {
        g = hinge(el, img);
        var w = img.clientWidth, h = img.clientHeight;
        var R = Math.ceil(Math.max(Math.hypot(g.x, g.y), Math.hypot(w - g.x, g.y), Math.hypot(g.x, h - g.y), Math.hypot(w - g.x, h - g.y)));
        var band = "conic-gradient(from " + g.from + "deg at 50% 50%, transparent " + (g.span - 36) + "deg, #000 " + g.span + "deg, transparent " + (g.span + 36) + "deg)";
        Object.assign(wrap.style, { left: (img.offsetLeft + g.x - R) + "px", top: (img.offsetTop + g.y - R) + "px", width: 2 * R + "px", height: 2 * R + "px", webkitMaskImage: band, maskImage: band });
        Object.assign(t.style, { left: (R - g.x) + "px", top: (R - g.y) + "px", width: w + "px", height: h + "px", objectPosition: getComputedStyle(img).objectPosition, transformOrigin: g.x + "px " + g.y + "px" });
      }
      t.onload = function () {
        place();
        el.appendChild(wrap);
        var o = { duration: 3000, iterations: Infinity, direction: "alternate", easing: "ease-in-out" };
        wrap.animate([{ transform: "rotate(0deg)" }, { transform: "rotate(" + -g.span + "deg)" }], o);
        t.animate([{ transform: "rotate(0deg)" }, { transform: "rotate(" + g.span + "deg)" }], o);
        requestAnimationFrame(function () { wrap.classList.add("rd-glint-on"); });
        if ("ResizeObserver" in window) new ResizeObserver(place).observe(img);
      };
      t.src = el.dataset.ticks;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        fetchNow(el);
        ready([].slice.call(el.querySelectorAll("img")), 15000).then(function () {
          el.classList.add("rd-in");
          setTimeout(function () {
            el.classList.add("rd-dial-done");
            var img = el.querySelector("picture img");
            if (img && img.naturalWidth) breathe(el, img);
          }, 600);
        });
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.35 });
    els.forEach(function (e) { io.observe(e); });
  }
  /* 06 fit scales: once either photo is on screen, both scales start on one clock: the glint sweeps
     Slim, then Standard right after, every 4s (SMIL; the order is baked into each animation) */
  function fitScales(root) {
    var els = [].slice.call((root || document).querySelectorAll(".rd-fitart--anim:not(.rd-in)"));
    if (!els.length) return;
    var still = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (still || !("IntersectionObserver" in window)) return;
    function start(sec) {
      var group = [].slice.call(sec.querySelectorAll(".rd-fitart--anim:not(.rd-in)"));
      group.forEach(function (el) { el.classList.add("rd-in"); io.unobserve(el); });
      setTimeout(function () {
        group.forEach(function (el) {
          [].forEach.call(el.querySelectorAll("animateTransform"), function (a) { try { a.beginElement(); } catch (e) {} });
        });
      }, 600);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.target.classList.contains("rd-in")) return;
        start(en.target.closest(".rd") || en.target.parentNode);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.35 });
    els.forEach(function (e) { io.observe(e); });
  }
  /* Sticky buy bar (rd-buybar). Same rules as the product page's bar: it shows once the hero has
     scrolled away; CSS keeps it hidden while the cookie banner is up; on phones it is placed from the
     visual viewport so it never slides behind Safari's or Instagram's bottom toolbar; the chat bubble
     shows with it (CSS, keyed on html classes set here). Explore opens a menu built from every section
     that has a menu label, highlights the one on screen and smooth-scrolls to the one picked. */
  function sbar() {
    var bar = document.querySelector(".rd-sbar");
    if (!bar || bar.__rdInit) return;
    bar.__rdInit = true;
    var html = document.documentElement;
    html.classList.add("rd-sbar-page");
    var btn = bar.querySelector(".rd-sbar-x"), menu = bar.querySelector(".rd-sbar-menu"), list = bar.querySelector(".rd-sbar-links");
    var still = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    var secs = [].slice.call(document.querySelectorAll("[data-rd-nav]")), links = [];
    /* the theme header is sticky: land each section just below it */
    function headerH() {
      var el = document.elementFromPoint(window.innerWidth / 2, 2), h = 0;
      while (el && el !== document.body) {
        var cs = getComputedStyle(el);
        if (cs.position === "fixed" || cs.position === "sticky") { h = el.getBoundingClientRect().bottom; break; }
        el = el.parentElement;
      }
      return Math.max(0, h);
    }
    function setOpen(on) {
      if (!btn) return;
      bar.classList.toggle("rd-open", on);
      html.classList.toggle("rd-sbar-open", on);
      btn.setAttribute("aria-expanded", on ? "true" : "false");
      menu.setAttribute("aria-hidden", on ? "false" : "true");
    }
    if (list) {
      list.innerHTML = "";
      secs.forEach(function (sec) {
        var li = document.createElement("li"), a = document.createElement("a");
        a.href = "#" + sec.id;
        a.textContent = sec.getAttribute("data-rd-nav");
        a.addEventListener("click", function (e) {
          e.preventDefault();
          setOpen(false);
          var y = sec.getBoundingClientRect().top + window.pageYOffset - headerH() - (sec.classList.contains("rd--first") ? 0 : 8);
          window.scrollTo({ top: Math.max(0, y), behavior: still ? "auto" : "smooth" });
        });
        li.appendChild(a); list.appendChild(li); links.push(a);
      });
    }
    if (btn && !links.length) btn.hidden = true;
    if (btn) {
      btn.addEventListener("click", function (e) { e.stopPropagation(); setOpen(!bar.classList.contains("rd-open")); });
      document.addEventListener("click", function (e) { if (bar.classList.contains("rd-open") && !bar.contains(e.target)) setOpen(false); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && bar.classList.contains("rd-open")) { setOpen(false); btn.focus(); } });
    }
    var hero = document.querySelector(".rd--first"), cur = -1, tick = 0;
    function update() {
      tick = 0;
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.pageYOffset > 400;
      bar.classList.toggle("rd-on", past);
      html.classList.toggle("rd-sbar-on", past);
      if (!past && bar.classList.contains("rd-open")) setOpen(false);
      /* the section on screen = the last one whose top has passed a line a third of the way down */
      var line = window.innerHeight / 3, idx = -1;
      secs.forEach(function (sec, i) { if (sec.getBoundingClientRect().top <= line) idx = i; });
      if (idx !== cur) {
        if (cur > -1 && links[cur]) links[cur].removeAttribute("aria-current");
        if (idx > -1 && links[idx]) links[idx].setAttribute("aria-current", "true");
        cur = idx;
      }
    }
    function fit() {
      var vv = window.visualViewport;
      if (!vv || window.innerWidth >= 900 || !bar.offsetHeight) { bar.style.top = ""; bar.style.bottom = ""; return; }
      var row = bar.querySelector(".rd-sbar-row");
      bar.style.top = Math.round(vv.offsetTop + vv.height - (row ? row.offsetHeight : bar.offsetHeight) - 12) + "px";
      bar.style.bottom = "auto";
    }
    function onScroll() { if (!tick) tick = requestAnimationFrame(function () { update(); fit(); }); }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    if (window.visualViewport) { visualViewport.addEventListener("resize", onScroll); visualViewport.addEventListener("scroll", onScroll); }
    update(); fit();
  }
  /* desktop exit popup on this page. Klaviyo's own URL rule keeps its exit popup off this page, so a
     visitor who LANDS here never sees it; once they have viewed another page this session (layout sets
     sessionStorage geo_seen), it opens here too on exit intent. Opening it by script skips Klaviyo's
     own rules, so they are repeated: desktop only, not for identified visitors (subscribers), not
     within 30 days of closing it, never after signing up. */
  function exitForm() {
    var el = document.querySelector("[data-rd-exit-form]");
    if (!el || el.__rdX) return;
    el.__rdX = true;
    var id = el.getAttribute("data-rd-exit-form");
    try { if (sessionStorage.getItem("geo_seen") !== "1") return; } catch (e) { return; }
    if (!window.matchMedia || !matchMedia("(pointer: fine) and (min-width: 768px)").matches || /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) return;
    try {
      var ck = (document.cookie.match(/(?:^|;\s*)__kla_id=([^;]*)/) || [])[1];
      if (ck) {
        var kla = JSON.parse(atob(decodeURIComponent(ck)));
        if (kla.$exchange_id || kla.$email || kla.$phone_number) return;
      }
    } catch (e) {}
    try {
      var st = JSON.parse(localStorage.getItem("klaviyoOnsite") || "{}");
      var d = st.viewedForms && st.viewedForms.modal && st.viewedForms.modal.disabledForms && st.viewedForms.modal.disabledForms[id];
      if (d) {
        if (d.successActionTypes && d.successActionTypes.length) return;
        var t = +d.lastCloseTime || 0;
        if (t && t < 1e12) t *= 1000;
        if (!t || Date.now() - t < 30 * 864e5) return;
      }
    } catch (e) {}
    function out(e) {
      if (e.relatedTarget || e.clientY > 8) return;
      document.removeEventListener("mouseout", out);
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", id]);
    }
    document.addEventListener("mouseout", out);
  }
  function init() { reveal(); grow(); dots(); preloadSlides(); dial(); fitScales(); sbar(); exitForm(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  /* theme editor: show sections straight away when they are added or edited */
  document.addEventListener("shopify:section:load", function (e) {
    [].forEach.call(e.target.querySelectorAll(".rd-rv, .rd-grow"), function (el) { el.classList.add("rd-in"); });
    [].forEach.call(e.target.querySelectorAll(".rd-dial--anim"), function (el) { el.classList.add("rd-in", "rd-dial-done"); });
    dots(e.target);
    preloadSlides(e.target);
    sbar();
  });
})();
